import { render } from "./futures.vue?vue&type=template&id=31de8b50"
import script from "./futures.vue?vue&type=script&lang=js"
export * from "./futures.vue?vue&type=script&lang=js"

import "./futures.vue?vue&type=style&index=0&id=31de8b50&lang=less"
script.render = render

export default script